var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_3119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5H16.5V0.5C16.5 0.367392 16.4473 0.240215 16.3536 0.146447C16.2598 0.0526784 16.1326 0 16 0L9 0V7.5Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5V0H1C0.867392 0 0.740215 0.0526784 0.646447 0.146447C0.552678 0.240215 0.5 0.367392 0.5 0.5L0.5 7.5H8Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5H0.5V15.5C0.5 15.6326 0.552678 15.7598 0.646447 15.8536C0.740215 15.9473 0.867392 16 1 16H8V8.5Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8.5V16H16C16.1326 16 16.2598 15.9473 16.3536 15.8536C16.4473 15.7598 16.5 15.6326 16.5 15.5V8.5H9Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_3119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoftIcon.11bb56ee000222046e1f925cc1c34b0d.svg";
export { ForwardRef as ReactComponent };